import { render, staticRenderFns } from "./opilased.vue?vue&type=template&id=ffa05ae2&"
import script from "./opilased.vue?vue&type=script&lang=js&"
export * from "./opilased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports